import { useLayoutEffect, useMemo, useRef, useState } from "react";
import { fitOfferCount, formatRub, rankedOffers } from "./catalog";
import type { WishlistGame, WishlistOffer } from "./types";

function SourcePill({ offer }: { offer: WishlistOffer }) {
  const text = offer.provider_enabled === false ? `${offer.label} · отключён` : `${offer.label}${offer.effective_price_kind === "ps_plus" ? " · PS+" : ""}${offer.effective_price_rub !== null ? ` · ${formatRub(offer.effective_price_rub)}` : " · Нет цены"}`;
  return <span className={offer.is_best ? "source-pill source-pill-best" : "source-pill"} title={text}>{text}</span>;
}

export function OfferPills({ game }: { game: WishlistGame }) {
  const offers = useMemo(() => rankedOffers(game), [game]);
  const [count, setCount] = useState(1);
  const root = useRef<HTMLSpanElement>(null);
  const measure = useRef<HTMLSpanElement>(null);
  useLayoutEffect(() => {
    const container = root.current, measurement = measure.current;
    if (!container || !measurement) return;
    const fit = () => {
      const elements = [...measurement.children] as HTMLElement[];
      const widths = elements.slice(0, -1).map(element => element.getBoundingClientRect().width);
      const more = elements.at(-1)?.getBoundingClientRect().width ?? 32;
      setCount(fitOfferCount(widths, more, container.clientWidth));
    };
    fit();
    const observer = new ResizeObserver(fit);
    observer.observe(container);
    void document.fonts.ready.then(fit);
    return () => observer.disconnect();
  }, [offers]);
  return <span className="offer-pills-container" ref={root}>
    <span className="source-pills source-pills-measure" ref={measure} aria-hidden="true">
      {offers.map(offer => <SourcePill key={offer.id} offer={offer} />)}<span className="source-pill">+{offers.length}</span>
    </span>
    <span className="source-pills">{offers.slice(0, count).map(offer => <SourcePill key={offer.id} offer={offer} />)}
      {count < offers.length ? <span className="source-pill source-pill-more" title="Откройте игру, чтобы увидеть все предложения">+{offers.length - count}</span> : null}
    </span>
  </span>;
}
